import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from './Portal';

function DeleteModal({
  title, children, handleClick, zIndex, positionMiddle, closeToggleDelete,
}) {
  const closeLittleModal = () => {
    handleClick();
    closeToggleDelete();
  };
  return (
    <Portal>
      <div className={`absolute w-full ${positionMiddle && 'h-full'} flex justify-center items-center pin-t pin-l `} style={{ zIndex: '9999' }}>
        <div className={`relative bg-black w-5/6 text-white rounded opacity-1 z-${zIndex || '60'} border-4 border-white rounded-sm shadow-xl`}>
          <div className="flex justify-between items-center w-full absolute p-1 border-b-1 border-white">
            <span className="font-americaMonoBold text-sm uppercase">{title}</span>
            <button type="button" onClick={closeToggleDelete}>
              <span className="font-icon icon-close-btn1 text-20 text-white" />
            </button>
          </div>
          <div className="pb-10 pt-16 flex flex-col justify-center items-center">
            <Fragment>
              {children}
              <button className="bg-white text-black rounded-full py-2 px-4 mt-4 w-1/4" type="button" onClick={closeLittleModal}>
                OK
              </button>
            </Fragment>
          </div>
        </div>
        <div className={`absolute w-full h-screen ${!zIndex && 'bg-black opacity-75'}`} onClick={closeLittleModal} />
      </div>
    </Portal>
  );
}

DeleteModal.propTypes = {
  title: PropTypes.string.isRequired,
  handleClick: PropTypes.func.isRequired,
  closeToggleDelete: PropTypes.func,
  children: PropTypes.string.isRequired,
  zIndex: PropTypes.string,
  positionMiddle: PropTypes.bool,
};

DeleteModal.defaultProps = {
  zIndex: null,
  closeToggleDelete: null,
  positionMiddle: true,
};

export default DeleteModal;
